<template>
    <el-container>
        <el-main>
            <el-result icon="success" title="提交成功" subTitle="感谢您对我们的真实评价，感恩有您">
                <template slot="extra">
                    <el-button type="primary" size="medium" @click="closeWin">关 闭</el-button>
                </template>
            </el-result>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods:{
        closeWin(){
            var isLppzApp = false
            var ua = navigator.userAgent.toLowerCase()
            var uaApp = ua ? ua.match(/BeStore/i) : '' // match方法返回的是对象
            var uaAndroid = /android/i.test(ua) // test返回的是true/false
            var uaIos = /iphone|ipad|ipod/i.test(ua);
            if(uaApp) {
                if (uaApp.toString() === 'bestore') { // 必须将match返回的对象转成字符串
                    isLppzApp = true
                } else {
                    isLppzApp = false
                }
            }
            if (window.WeixinJSBridge) {
                window.WeixinJSBridge.call('closeWindow') // 微信，只是微信就用这个API。
            } else if (window.AlipayJSBridge) {
                window.AlipayJSBridge.call('closeWebview') // 支付宝
            } else if (isLppzApp && uaAndroid) {
                window.obj.closePageLppzRequest('') // 安卓app
            } else if (isLppzApp && uaIos) {
                window.webkit.messageHandlers.closePageLppzRequest.postMessage('') //ios app
            }
            else{
                window.opener = null
                window.open('about:blank', '_top').close()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/check/visitsucess.vue